import BaseService from './BaseService';
import * as apiroutes from '../apiRoutes';

class OrderItemService extends BaseService {
    constructor() {
        super(apiroutes.ORDER_ITEM);
    }

    async getAllOrderItems(params = {}) {
        return await super.customCall('GET', '', null, params, null);
    }

    async getOrderItemById(id, params = {}) {
        return await super.customCall('GET', `/${id}`, null, params, null);
    }

    async addOrderItem(data) {
        return await super.customCall('POST', '', data, null, 'json');
    }

    async updateOrderItem(id, data) {
        return await super.customCall('PATCH', `/${id}`, data, null, 'json');
    }

    async updateOrderItemStatus(id, data) {
        return await super.customCall('PUT', `/${id}/status`, data, null, 'json');
    }

    async deleteOrderItem(id, params = {}) {
        return await super.customCall('DELETE', `/${id}`, null, params, null);
    }
}

const OrderItemServices = new OrderItemService();

export default OrderItemServices;
